import { useContext } from "react";
import { Button } from "../ui/button"
import { AppContext } from "@/App";
import { formatDate } from "date-fns";
import { dateformat } from "../../utils/GlobalConstants";
import { PageLockContext } from "../PageLockProvider";
import HelpLink from "../ui/help-link";
import { Charter, CharterContext } from "./Charter";
import { useIsMobile } from "@/hooks/use-mobile";
import UpcomingDeliverablesTable from "../UpcomingDeliverables_table/UpcomingDeliverablesTable";

export type ListWithTitle = {
    title: string
    items: unknown[]
}

export type ProjectDeliverablesSimpleList = {
    title: string
    items: ListWithTitle[]
}

interface CharterPageProps {
    disableApprove: boolean
}

const Page2_Content = ({ disableApprove }: CharterPageProps) => {
    const app = useContext(AppContext);
    const isMobile = useIsMobile();
    const charterContext = useContext(CharterContext);
    const charter = charterContext.charterData as Charter;
    const lock = useContext(PageLockContext);

    function handleApprove() {
        document.body.style.cursor = 'wait';
        fetch(`Projects/ApproveCharter/${app.selectedProject?.id}/${app.applicationUser?.id}/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.status === 204) {
                    charterContext.refreshCharterData();
                }
            })
            .finally(() => {
                document.body.style.cursor = 'default';
            });
    }

    if (isMobile) {
        return (
            <div className="flex flex-col">
                <div className="flex flex-row absolute top-0 right-2 -translate-y-[125%]">{lock.getRefreshControl()}{(app.authLevel == 4 || app.authLevel == 5) && lock.getLockControl()}</div>
                <UpcomingDeliverablesTable visibility={{ workstream: false, workPackage: true, deliverable: true, actualFinish: false, status: false, plannedFinish: true, owner: true, id: false }} />
                <div className="flex flex-col mt-4">
                    <div className="flex flex-row text-2xl m-4">
                        <span>Project Sponsor : </span><span className="font-bold ml-4"> {charter.sponsorApprovalDate ? charter.sponsorName + " - " + formatDate(charter.sponsorApprovalDate, dateformat) : "______________"} </span>
                    </div>
                    {(app.authLevel === 3 && charter.submittedForApproval) &&
                        <Button className="bg-blue-600 h-12 text-2xl text-white rounded-md p-1 mx-2 mt-4" disabled={app.authLevel < 3 || disableApprove} onClick={handleApprove}>Approve</Button>}
                    {app.authLevel > 3 && !lock.viewOnly && !charter.sponsorApprovalDate && (
                        <>
                            <Button className="bg-blue-600 h-12 text-2xl text-white rounded-md p-1 mx-2 mt-4" disabled={charter.submittedForApproval} onClick={charterContext.submitCharterForApproval}>{charter.submittedForApproval ? "Submitted " : "Submit "}For Approval</Button>
                            {(charter.submissionSeen) && <span className=" ml-4 mt-2"> - Seen by Sponsor.</span>}
                        </>
                    )}
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col">
            <div className="flex flex-row ml-auto w-min text-nowrap">{lock.getRefreshControl()}{(app.authLevel == 4 || app.authLevel == 5) && lock.getLockControl()}<HelpLink page="charter" /></div>
            <UpcomingDeliverablesTable visibility={{ workstream: false, workPackage: true, deliverable: true, actualFinish: false, status: false, plannedFinish: true, owner: true, id: false }} />
            <div className="flex flex-row mt-4">
                <span>Project Sponsor : </span><span className="font-bold ml-4"> {charter.sponsorApprovalDate ? charter.sponsorName + " - " + formatDate(charter.sponsorApprovalDate, dateformat) : "______________"} </span>
                {(app.authLevel === 3 || app.authLevel === 5 && charter.submittedForApproval) ? (
                    <Button className="bg-blue-600 text-white rounded-md p-1 ml-4" disabled={app.authLevel < 3 || disableApprove} onClick={handleApprove}>Approve</Button>
                ) : (
                    app.authLevel > 3 && !lock.viewOnly && !charter.sponsorApprovalDate && (
                        <>
                            <Button className="bg-blue-600 text-white rounded-md p-1 ml-4" disabled={charter.submittedForApproval} onClick={charterContext.submitCharterForApproval}>{charter.submittedForApproval ? "Submitted " : "Submit "}For Approval</Button>
                            {(charter.submissionSeen) && <span className=" ml-4"> - Seen by Sponsor.</span>}
                        </>
                    )
                )}
            </div>

        </div>
    )
}

export default Page2_Content